<template>
    <div class="cpf-modal-container" :class="{'androidMode': isAndroidMode()}">
        <div class="bg">
            <h2 v-if="blockCnpjPdv">{{ getString('informe_cpf') }} </h2>
            <h2 v-else>{{ getString('informe_cpf_cnpj') }} </h2>
            <div class="radios" v-if="!blockCnpjPdv">
                <div class="container-input">
                    <input type="radio" class="styled-input" :class="{'selected' : true}" name="informa_cpf" id="cpf" checked value="cpf" v-model="dynamicMask">
                    <span class="checkmark"></span>
                </div>
                <label for="cpf">{{ getString('CPF') }}</label>

                <div class="container-input" >
                    <input type="radio" class="styled-input" name="informa_cpf" id="cnpj" value="cnpj" v-model="dynamicMask">
                    <span class="checkmark"></span>
                </div>
                <label for="cnpj" v-if="!blockCnpjPdv">{{ getString('CNPJ') }}</label>
            </div>
            <div class="input-container" :class="hasError ? 'error-shake' : ''">
                <!-- <input
                    id="cpf-cnpj"
                    type="text"
                    inputmode="numeric"
                    v-mask="dynamicMask"
                    placeholder="###.###.###-##"
                    v-model="idCliValue"
                    @focus="show"
                    data-layout="numeric"
                    autocomplete="off"
                    @input="sanitizeCpfCnpj"
                /> -->
                <div id="cpf-cnpj" class="div-input-android" :class="{'error-signal': hasError}"></div>
                <span v-if="errorMessage" class="error-message"> {{ errorMessage }}</span>
            </div>
            <!-- <div v-if="dynamicMask === 'cnpj'">
                <div id="cep" :class="{'error-signal': hasError}"></div>
                <span class="qst">{{ getString('formato_cpf') }}</span>
            </div> -->
            <div class="buttons-container">
                <DefaultButton v-for="(btn, key) in buttons" :key="key"
                    :text="btn.text" @defaultBtnClick="btn.action()" class="buttons">
                </DefaultButton>
            </div>

        <CepModal
            v-if="showCepModal"
            @close="showCepModal = false"
            @address="handleAddressData"/>

            <AndroidKeyboard id="android-keyboard"
                :inputElement="inputElement"
                :layout="dynamicMask === 'cpf' ? layout : alphanumericLayout"
                :bigNumeric="dynamicMask === 'cpf'"
                :onInput="applyMask"
                :maxCaracteres="dynamicMask === 'cpf' ? 14 : 18">
            </AndroidKeyboard>
        </div>
        <!-- <vue-touch-keyboard id="keyboard" :options="options" v-if="visible" :layout="layout" :data-layout="layout" :cancel="hide" :accept="accept" :input="input"/> -->
    </div>
</template>

<script>
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton.vue'
import ValidaCpfCnpj from '@/assets/libs/cpfcnpj'
import LocaleController from '@/assets/controllers/LocaleController'
import CepModal from '@/components/CepModal.vue'
// import Vue from 'vue'
// import VueTouchKeyboard from 'vue-touch-keyboard'
// import style from 'vue-touch-keyboard/dist/vue-touch-keyboard.css'
// Vue.use(VueTouchKeyboard)
// Vue.use(style)

export default {
    name: 'IdentificationModal',
    components: {
        DefaultButton,
        AndroidKeyboard,
        CepModal
        // 'vue-touch-keyboard': VueTouchKeyboard.component
    },
    props: ['cpf'],
    data () {
        return {
            inputElement: null,
            visible: false,
            hasError: false,
            showCepModal: false,
            errorMessage: '',
            layout: keyboardLayout.SIMPLE_PHONE_NUMBER,
            alphanumericLayout: keyboardLayout.ALPHANUMERIC_CNPJ,
            input: null,
            dynamicMask: 'cpf',
            idCliValue: '',
            cpfValue: '',
            cnpjValue: '',
            blockCnpjPdv: Util.getLocalConfigs('blockCnpjPdv'),
            options: {
                useKbEvents: false,
                preventClickEvent: false
            },
            buttons: [
                {
                    text: this.getString('cancelar'),
                    action: this.cancel
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm
                }
            ]
        }
    },
    mounted () {
        this.inputElement = document.getElementById('cpf-cnpj')
        if (this.cpf) {
            if (this.cpf.length > 14) {
                this.cnpjValue = this.cpf
                this._isInitializing = true
                this.dynamicMask = 'cnpj'
            } else {
                this.cpfValue = this.cpf
                this.idCliValue = this.cpf
                this.inputElement.innerText = this.cpf
            }
            this.buttons[0].text = this.getString('remover')
        }
    },
    watch: {
        dynamicMask: function (newmask, oldmask) {
            this.errorMessage = ''
            this.hasError = false

            if (!this._isInitializing) {
                if (oldmask === 'cpf') this.cpfValue = this.idCliValue
                else this.cnpjValue = this.idCliValue
            }
            this._isInitializing = false

            const restored = newmask === 'cpf' ? this.cpfValue : this.cnpjValue
            this.idCliValue = restored
            if (this.inputElement) this.inputElement.innerText = restored
        }
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        accept: function (text) {
            this.hide()
        },
        show: function (e) {
            if (!Util.isAndroidMode()) {
                this.input = e.target
                if (!this.visible) {
                    this.visible = true
                }
            }
        },
        hide: function () {
            this.visible = false
        },
        cancel: function () {
            if (this.cpf) {
                this.idCliValue = ''
                this.$emit('setIdCliValue', this.idCliValue)
            }
            this.$emit('closeCpfModal')
        },
        confirm: async function () {
            this.idCliValue = document.getElementById('cpf-cnpj').innerText.trim().replace(/\s+/g, '')
            if (!ValidaCpfCnpj.validaCpfCnpj(this.idCliValue)) {
                this.errorMessage = this.getString('CPF_CNPJ_invalido')
                console.log('CPF/CNPJ invalido')
                this.showError()
                return false
            }

            if (this.dynamicMask === 'cnpj') {
                const dtPortariaNfce = Util.getLocalConfigs('dtPortariaNfce')
                if (!dtPortariaNfce) {
                    this.$emit('setIdCliValue', this.idCliValue)
                    return false
                }
                if (dtPortariaNfce) {
                    const portariaDate = new Date(dtPortariaNfce)
                    const today = new Date()

                    if (portariaDate > today) {
                        this.$emit('setIdCliValue', this.idCliValue)
                    } else {
                        this.showCepModal = true
                    }
                }
            } else {
                this.$emit('setIdCliValue', this.idCliValue)
            }
        },
        showError: function () {
            this.hasError = true
            // const sf = this
            // sf.hasError = true
            // setTimeout(() => {
            //     sf.hasError = false
            // }, 500)
        },
        sanitizeCpfCnpj: function () {
            this.errorMessage = ''
            if (this.dynamicMask === 'cpf') {
                this.idCliValue = this.idCliValue.replace(/[^0-9.-]+/g, '')
            } else {
                this.idCliValue = this.idCliValue.replace(/[^A-Z0-9/.-]+/g, '').toUpperCase()
            }
        },
        applyMask: function (input) {
            if (!input) return ''

            if (this.dynamicMask === 'cpf') {
                input = input.replace(/\D/g, '')
                return this.applyCpfMask(input)
            } else {
                input = input.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
                return this.applyCnpjMask(input)
            }
        },
        applyCpfMask: function (input) {
            if (input.length < 7) {
                return input.replace(/(\d{3})(\d)/, '$1.$2')
            } else if (input.length >= 7 && input.length < 10) {
                return input.replace(/(\d{3})(\d{3})(\d)/, '$1.$2.$3')
            } else {
                return input.replace(/(\d{3})(\d{3})(\d{3})(\d)/, '$1.$2.$3-$4')
            }
        },
        applyCnpjMask: function (input) {
            if (input.length < 6) {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
            } else if (input.length >= 6 && input.length < 9) {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
            } else if (input.length >= 9 && input.length < 13) {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4')
            } else {
                return input.replace(/([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/, '$1.$2.$3/$4-$5')
            }
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        handleAddressData: function (addressData) {
            this.showCepModal = false

            this.$emit('setIdCliValue', this.idCliValue, addressData)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
    @import (reference) url("../assets/common.less");

    .cpf-modal-container{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        background: rgba(0, 0, 0, 0.5);
        /* Flexbox para centralização robusta */
        display: flex;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flexbox;
        align-items: center;
        justify-content: center;
        -webkit-align-items: center;
        -webkit-justify-content: center;
        -moz-align-items: center;
        -moz-justify-content: center;
        -ms-flex-align: center;
        -ms-flex-pack: center;
        /* Fallback para webviews antigos */
        text-align: center;
        &:before {
            content: '';
            display: inline-block;
            height: 100%;
            vertical-align: middle;
            margin-right: -0.25em;
        }
    .bg {
        position: relative;
        background: white;
        padding: 30px;
        border-radius: 25px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        width: 100%;
        max-width: 700px;
        margin: 0 150px;
        /* Centralização inline-block para webviews antigos */
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        // opacity: 1;
        .radios {
                text-align: center;
                font-size: 2rem;
                margin-bottom: 2rem;

                input {
                    margin-left: 2rem;
                }
                .container-input {
                    height: 37px;
                    display: inline-block;
                    vertical-align: middle;
                    #cpf, #cnpj{
                        margin: 0;
                    }
                    .checkmark {
                        margin: 0;
                        border-radius: 100%;
                        pointer-events: none;
                        &:after {
                            border: none;
                            background: white;
                            border-radius: 100%;
                            width: 10px;
                            left: 8px;
                            top: 7px;
                        }
                    }
                }
                label {
                    display: inline-block;
                    vertical-align: middle;
                    &:not(&:last-of-type) {
                        margin-right: 30px;
                    }
                }
            }
        img {
            display: block;
            margin: auto;
            width: 100px;
            height: 100px;
            border: solid 1px;
            border-radius: 100%;
            object-fit: contain;
            padding: 10px;
        }
        h2, span, img {
            display: block;
            font-size: 2rem;
            margin: auto;
            text-align: center;
        }
        h2, span.qst {
            margin: 15px 0;
            font-weight: bold;
        }
        .input-container {
            margin: 40px 0;
            .div-input-android {
                position: relative;
                margin: 50px 0px;
                display: block;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 3.5rem;
                height: 85px;
                background-color: white;
                color: black;
                border: 2px solid black;
                border-radius: 20px;
                padding: 0 20px;
            }
            .error-signal {
                border: 4px solid red;
            }
        }
        .buttons-container {
            margin: 50px 0;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-content: center;
            justify-content: space-around;
            align-items: center;
            button:first-of-type{
                background: white;
                border: solid 1px black;
                color: black;
            }
        }
    }
    #keyboard {
        .keyboard;
        width: inherit;
        max-width: 930px;
        top: inherit;
        position: unset;
        bottom: 0;
    }
    @keyframes shake {
        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
    &.androidMode {
    .bg {
        margin: 0 80px;
        padding-bottom: 0;
    }
    }
}

@media (max-width: 698px) { // Gertec SK210
    .cpf-modal-container {
        .bg {
            margin: 0 50px !important;
            padding: 10px 10px 0 10px;
            h2 {
                font-size: 20px;
            }
            .radios {
                font-size: 20px;
                margin-bottom: 15px;
            }
            .input-container {
                margin: 0 20px;
                .div-input-android {
                    margin: 10px 0;
                    font-size: 25px;
                    height: 35px;
                    padding: 0 10px;
                    border-radius: 5px;
                }
            }
            .buttons-container {
                margin: 20px 0 5px 0;
            }
            #android-keyboard {
                margin: 0;
                .small-screen-keyboard;
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .cpf-modal-container{
            .bg {
                margin: 0 40px;
                .buttons-container {
                    button {
                        min-width: 220px;
                    }
                }
            }
        }
}
@media (orientation: landscape) {
        .cpf-modal-container {
            .bg {
                margin: 0 160px !important;
                padding: 10px 30px 0 30px;
                h2 {
                    font-size: 25px;
                }
                .radios {
                    font-size: 20px;
                    margin-bottom: 15px;
                }
                .input-container {
                    margin: 0 20px;
                    .div-input-android {
                        margin: 10px 0;
                        font-size: 25px;
                        height: 35px;
                        padding: 0 10px;
                        border-radius: 5px;
                    }
                }
                .buttons-container {
                    margin: 20px 0 5px 0;
                }
                #android-keyboard {
                    margin: 0;
                    .small-screen-keyboard;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/CPFModal.vue